"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateUrlParameter = updateUrlParameter;
// 添加、删除或更新url参数
function updateUrlParameter(url, key, value) {
  if (!value) {
    var reg = new RegExp('(\\?|&)' + key + '=[^&]*(&)?', 'g');
    var newUrl = url.replace(reg, function (match, p1, p2) {
      return p1 === '?' || p2 ? p1 : '';
    });
    return newUrl[newUrl.length - 1] === '?' ? newUrl.substr(0, newUrl.length - 1) : newUrl;
  }
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = url.indexOf('?') !== -1 ? "&" : "?";
  if (url.match(re)) {
    return url.replace(re, '$1' + key + "=" + value + '$2');
  } else {
    return url + separator + key + "=" + value;
  }
}